export const DEFAULT_LITIGATION_PAGE = "/admin/litigation/batch";

export const litigrationPages = [
  { key: "batch", route: "/admin/litigation/batch" },
  { key: "cases", route: "/admin/litigation/cases" },
];